import React from "react";
import Template from "../../../../templates/Crew/NoonReport/Create/Complete";
import Default from "../../../../layouts/DefaultCrew";

const Complete = (): React.ReactElement => {
  return (
    <Default title="" selectedTitle={"Noon Report"}>
      <Template />
    </Default>
  );
};

export default Complete;
